import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ServiceTradeSettings from './ServiceTradeSettings';

// Create QueryClient once at module level to preserve cache across renders
const queryClient = new QueryClient();

export default function ServiceTrade(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <ServiceTradeSettings initialData={props} />
    </QueryClientProvider>
  );
}

ServiceTrade.propTypes = {
  hasIntegration: PropTypes.bool.isRequired,
  needsReauth: PropTypes.bool.isRequired,
  username: PropTypes.string,
  vendorId: PropTypes.string,
  selectedOfficeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  importStatus: PropTypes.string.isRequired,
  hasCalifornia: PropTypes.bool.isRequired,
  settings: PropTypes.object.isRequired
};
